module.exports = __webpack_public_path__ + "static/media/MirateAlEspejoPortada.2da2797d.jpeg";